import React, {useRef, useEffect} from 'react';

import Toast,{type ToastData} from "../Toast/Toast";

import "./ToastList.css";

export type Positions = "top-left" | "top-right" | "bottom-left" | "bottom-right";

export interface ToastListProps{
    data: ToastData[],
    position: Positions,
    removeToast: any
}
function ToastList(props:ToastListProps){
    const {data, position, removeToast} = props;
    const listRef = useRef(null);

    const handleScrolling = (el:any) => {
    const isTopPosition = ["top-left", "top-right"].includes(position);
    if (isTopPosition) {
      el?.scrollTo(0, el.scrollHeight);
    } else {
      el?.scrollTo(0, 0);
    }
    };

    useEffect(() => {
    handleScrolling(listRef.current);
    }, [position, data]);

    const sortedData = position.includes("bottom")
    ? [...data].reverse()
    : [...data];

    return(
        sortedData.length > 0 &&(
        <div className={`toast-list toast-list--${position}`} aria-live="assertive"> 
            {sortedData.map((toast)=>(
            <Toast 
            key = {toast.id}
            message = {toast.message}
            type = {toast.type}
            onClose={()=> removeToast(toast.id)}
            />
          ))}
        </div>
        )
    )
};

export default ToastList;
